import React from "react";
import { FormConfiguration } from "../FormConfiguration";
import { FormRuntime } from "../FormRuntime";
import { XColumnContainer, XColumnContainerColumn } from "./XColumnContainer";
import { TextFormControl } from "../Controls/Web/TextFormControl";
import { WidthUnitInterface } from "../Utilities/FormDesignConstants";
import { DefaultOnOff } from "../Utilities/DefaultOnOff";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

function getUI(thirdColumn?: boolean): {
    form: FormConfiguration;
    colContainer: XColumnContainer;
    col1: XColumnContainerColumn;
    col2: XColumnContainerColumn;
    col3?: XColumnContainerColumn;
} {
    let ui = new FormConfiguration();
    let columnContainer = new XColumnContainer();
    let actualCol = new XColumnContainerColumn();
    let actualCol2 = new XColumnContainerColumn();
    // show border so we can see
    columnContainer.overrideFormBorderSettings = DefaultOnOff.On;
    columnContainer.showContainerBorder = true;
    columnContainer.defaultShowColumnBorder = true;

    columnContainer.add(actualCol);
    columnContainer.add(actualCol2);
    actualCol.add(new TextFormControl());
    actualCol.add(new TextFormControl());
    actualCol.add(new TextFormControl());
    actualCol2.add(new TextFormControl());
    actualCol2.add(new TextFormControl());
    actualCol2.add(new TextFormControl());
    let actualCol3: XColumnContainerColumn | undefined = undefined;
    if (thirdColumn) {
        let actualCol3 = new XColumnContainerColumn();
        columnContainer.add(actualCol3);
        actualCol3.targetWidth = 200;
        actualCol3.maxSizePx = 200;
        actualCol3.widthUnit = WidthUnitInterface.PIXEL;
        actualCol3.add(new TextFormControl());
        actualCol3.add(new TextFormControl());
        actualCol3.add(new TextFormControl());
    }
    ui.add(columnContainer);

    return { form: ui, colContainer: columnContainer, col1: actualCol, col2: actualCol2, col3: actualCol3 };
}

export const ContainerColumnStories = [
    new StoryNode(
        () => {
            let ui = getUI();

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Two Column 50 Percent",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.col1.targetWidth = 70;
            ui.col1.targetWidth = 30;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Two Column 70-30 Percent",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.col1.targetWidth = 70;
            ui.col1.targetWidth = 50;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Two Column 70-50 Percent",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.col1.targetWidth = 30;
            ui.col1.targetWidth = 60;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Two Column 60-30 Percent",
    ),
    new StoryNode(
        () => {
            let ui = getUI(true);
            ui.col1.targetWidth = 10;
            ui.col1.minSizePx = 100;
            ui.col1.maxSizePx = 100;
            ui.col2.targetWidth = 70;
            ui.col2.maxSizePx = 300;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Three Column With Space",
    ),
    new StoryNode(
        () => {
            let ui = getUI(true);
            ui.col1.targetWidth = 10;
            ui.col1.minSizePx = 200;
            ui.col1.maxSizePx = 300;
            ui.col2.targetWidth = 70;
            ui.col2.maxSizePx = 300;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Three Column With Min Sizes",
    ),
    new StoryNode(
        () => {
            return <>missing</>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Responsive Layout (Missing)",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.colContainer.lineBetweenColumns = true;
            ui.colContainer.defaultShowColumnBorder = false;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Line Between Columns - No Border",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.colContainer.paddingBetweenContainerAndColumns = 50;

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Container Column Space",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.colContainer.gapBetweenColumns = 40;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Columns Space",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.col1.targetWidth = 30;
            ui.col1.targetWidth = 60;
            ui.colContainer.containerBackgroundColor = "blue";
            ui.colContainer.defaultColumnBackgroundColor = "red";
            ui.colContainer.defaultShowColumnBorder = true;
            ui.colContainer.defaultColumnBorderColor = UIStyleConstants.YELLOW_COLOR;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "From Form Column Color and Border",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.col1.targetWidth = 30;
            ui.col1.targetWidth = 60;
            ui.colContainer.containerBackgroundColor = "blue";
            ui.colContainer.defaultColumnBackgroundColor = "red";
            ui.col1.columnBackgroundColor = "yellow";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Colors and Border Override",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.form.defaultInterControlSpacing = 40;

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "From Form - Spacing Between Controls",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.form.defaultInterControlSpacing = 40;
            ui.col1.interControlSpacing = 10;
            ui.col2.interControlSpacing = 50;

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Override Spacing Between Controls",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.form.defaultInnerColumnMargin = 40;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "From Form - Inner Margin",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.form.defaultInnerColumnMargin = 40;
            ui.colContainer.defaultInnerColumnMargin = 20;
            ui.col2.innerMargin = 80;

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Column Container",
        "Override Form Inner Margin",
    ),
];
